import { App } from 'vue';
import action from './action';
export default function initDirective(app: App<Element>) {
  app.directive(action.name, action.directive);
}
